import { render, staticRenderFns } from "./jiancha-detail.vue?vue&type=template&id=5640e2e5&scoped=true&"
import script from "./jiancha-detail.vue?vue&type=script&lang=ts&"
export * from "./jiancha-detail.vue?vue&type=script&lang=ts&"
import style0 from "./jiancha-detail.vue?vue&type=style&index=0&id=5640e2e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640e2e5",
  null
  
)

export default component.exports